// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"566":"c0a54ab8","645":"8ecab4d8"}[chunkId] + ".chunk.js";
};